import {useControllers} from '../../../../../common/helpers/react/hooks/useControllers';
import {useConfigurationsTableColumns} from './useConfigurationsTableColumns';
import DefaultTable from '../../../common/components/table/DefaultTable';
import {toServerSortingConfig} from '../../../common/components/table/helpers/toServerSortingConfig';

export const ConfigurationsTable = () => {
    const configurations = useControllers().configurations;
    const redApps = useControllers().redApps;
    const columns = useConfigurationsTableColumns();
    const redappsData = redApps.getRedApps$().useState() ?? [];
    const configurationsData = configurations.getConfigurations$().useState() ?? [];
    const sortingState = configurations.getSortingState$().useState();
    const data = configurationsData.map(configuration => ({
        ...configuration,
        redapp_name: redappsData.find(redapp => redapp.iu_name === configuration.redapp_name)?.name ?? configuration.redapp_name
    }));
    const isBusy = configurations.isBusy$().useState() !== false;

    const sorting = toServerSortingConfig(sortingState, (sortBy, sortOrder) =>
        configurations.changeSorting(sortBy, sortOrder), 'redappName');

    return <DefaultTable
        columns={columns}
        data={data}
        isBusy={isBusy}
        sorting={sorting}
    />;
};